import { Info, LineChart } from 'lucide-react';
import type { DailySummaryResponse } from '@pnl/shared';
import { formatBrl, formatDateShort, formatNumber } from '../../lib/format';
import { Card } from './Card';

interface Props {
  data: DailySummaryResponse;
}

export function DailySummary({ data }: Props) {
  return (
    <Card
      title={
        <span className="flex items-center gap-1.5">
          Resumo Diário
          <Info size={12} className="text-ink-500" />
        </span>
      }
      action={
        <button
          type="button"
          onClick={() => console.info('TODO: visão gráfica do resumo')}
          className="text-ink-400 hover:bg-ink-800 hover:text-ink-200 rounded-md p-1.5"
          title="Ver em gráfico"
        >
          <LineChart size={16} />
        </button>
      }
    >
      {/* Altura fixa no desktop. Sem isso, a conta SEM operações encolhia a linha
          inteira do grid — e como Estatísticas e Resumo Diário esticam juntos, o
          card ao lado perdia ~190px também. O dashboard de quem acabou de comprar
          ficava "murcho" ao lado do de quem já opera (feedback do cliente). */}
      <div className="max-h-[420px] overflow-y-auto lg:h-[420px]">
        {data.entries.length === 0 ? (
          <div className="flex h-full min-h-[160px] items-center justify-center px-5 py-10">
            <p className="text-ink-400 text-sm">Sem operações no período</p>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-ink-900 sticky top-0">
              <tr className="border-ink-800 text-2xs text-ink-400 border-b text-left font-medium">
                <th className="px-5 py-3 font-medium">Data</th>
                <th className="px-2 py-3 text-right font-medium">Posições</th>
                <th className="px-2 py-3 text-right font-medium">Lots</th>
                <th className="px-5 py-3 text-right font-medium">Resultado</th>
              </tr>
            </thead>
            <tbody>
              {data.entries.map((e) => {
                const tone =
                  e.pnlCents > 0
                    ? 'text-success-300'
                    : e.pnlCents < 0
                      ? 'text-danger-300'
                      : 'text-ink-200';
                return (
                  <tr key={e.date} className="border-ink-800 border-b last:border-b-0">
                    <td className="text-brand-500 px-5 py-3 text-xs font-semibold tabular-nums">
                      {formatDateShort(e.date)}
                    </td>
                    <td className="text-ink-200 px-2 py-3 text-right tabular-nums">
                      {e.positions}
                    </td>
                    <td className="text-ink-200 px-2 py-3 text-right tabular-nums">
                      {formatNumber(e.lots, 1)}
                    </td>
                    <td className={'px-5 py-3 text-right font-semibold tabular-nums ' + tone}>
                      {formatBrl(e.pnlCents, { signed: true })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </Card>
  );
}
